class c {
  constructor() {
    this.name = "ViewManager", this.views = [];
  }
  initViews(e = document.querySelector("html")) {
    this.clearViews();
    let t = e.querySelectorAll("[me\\:view]"), i = [];
    for (let s = 0; s < t.length; s++) {
      let n = t[s], a = n.getAttribute("me:view"), w = { el: n, name: a, params: {} };
      if (typeof Me.views[a] != "function") {
        console.warn("You need to have view that exist.", a);
        continue;
      }
      if (n.hasAttribute("me:view:render"))
        continue;
      n.setAttribute("me:view:render", "true");
      let o = n.getAttribute("me:view:data");
      w.params = o ? JSON.parse(o) : {};
      let v = new Me.views[a](w);
      this.views.push(v), i.push(v);
    }
    for (const s in i)
      i[s].initialize();
    for (const s in i) {
      var r = i[s];
      r.afterAllViewInitialized || (r.afterAllViewInitialize(), r.afterAllViewInitialized = !0);
    }
  }
  clearViews() {
    let e = [];
    for (let t in this.views) {
      let i = this.views[t];
      typeof i == "object" && (document.body.contains(i.el) ? e.push(i) : i.terminate());
    }
    this.views = e;
  }
  toString() {
    return this.name;
  }
}
window.Me || (window.Me = {});
Me.manage = new c();
Me.views = [];
document.addEventListener("DOMContentLoaded", (l) => {
  Me.manage.initViews();
});
class h {
  defaults() {
    return {};
  }
  constructor(e) {
    this.name = e.name ? e.name : "ViewBasic", this.options = {
      debug: window.SETTINGS && SETTINGS.DEBUG_MODE ? SETTINGS.DEBUG_MODE : !1
    }, this.el = e.el, this.params = Object.assign(this.defaults(), e.params);
  }
  initialize() {
    this.addEvents();
  }
  afterAllViewInitialize() {
  }
  addEvents() {
  }
  removeEvents() {
  }
  terminate() {
    this.removeEvents();
  }
  toString() {
    return this.name;
  }
  bindAll(e = []) {
    e.forEach((t) => {
      typeof this[t] == "function" && (this[t] = this[t].bind(this));
    });
  }
}
Me.views.ViewBasic = h;
export {
  h as ViewBasic,
  c as ViewManager
};
